window.$ = $ = jQuery331;
require('./1-tools');
require('./2-components');

